import { render } from "./adminrestaurants.vue?vue&type=template&id=602b47dc"
import script from "./adminrestaurants.vue?vue&type=script&lang=js"
export * from "./adminrestaurants.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__